import { Auth } from "@aws-amplify/auth";

// Using Auth.currentSession() will auto refresh an expired
// access token with the provided refresh token, preventing
// users from having API access revoked after the access token
// expiration. When the refresh token expires (usually longer),
// then the user will need to re-authenticate
export const getAccessToken = async () => {
  const session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
};
